import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

// Premium branded page-load intro: blue KYT logo on warm paper,
// a hairline draws beneath it, then the panel lifts away (curtain) to
// reveal the hero. Shown once per browser session.
export default function Intro() {
  const [show, setShow] = useState(() => {
    if (typeof window === "undefined") return false;
    return !sessionStorage.getItem("kyt_intro_seen");
  });

  useEffect(() => {
    if (!show) return;
    document.body.style.overflow = "hidden";
    const t = setTimeout(() => {
      sessionStorage.setItem("kyt_intro_seen", "1");
      document.body.style.overflow = "";
      setShow(false);
    }, 1500);
    return () => {
      clearTimeout(t);
      document.body.style.overflow = "";
    };
  }, [show]);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          className="fixed inset-0 z-[100] bg-paper flex items-center justify-center"
          data-testid="intro-overlay"
          initial={{ opacity: 1 }}
          exit={{ y: "-101%", transition: { duration: 0.9, ease: [0.76, 0, 0.24, 1] } }}
        >
          <div className="absolute inset-0 grain-layer opacity-[0.04]" />
          <motion.div
            className="relative flex flex-col items-center"
            initial={{ opacity: 0, y: 16, scale: 0.97 }}
            animate={{ opacity: 1, y: 0, scale: 1, transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1] } }}
          >
            <img src="/logo.png" alt="KYT Yapı Teknolojileri" className="h-16 md:h-20 w-auto" />
            <motion.span
              className="mt-7 h-px bg-brand-blue/70 block"
              initial={{ width: 0 }}
              animate={{ width: 132, transition: { duration: 1, ease: [0.22, 1, 0.36, 1], delay: 0.25 } }}
            />
            <motion.span
              className="mt-5 font-mono text-[10px] tracking-[0.4em] uppercase text-ink/45"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1, transition: { duration: 0.8, delay: 0.5 } }}
            >
              Est. 1993 — İzmit / Kocaeli
            </motion.span>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
